module.exports = __webpack_public_path__ + "static/media/logo.bd77970b.png";